import * as React from 'react';
import { BaseInputField } from '../../components/BaseInputField';
import { intGuard, numberParser, priceFormatter } from '../../utils';

/**
 * @deprecated
 * Используйте NumberFieldContainer (EFieldType.Number) с указанием decimalDigits (цена с копейками) или без (цена без копеек).
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var PriceFieldContainer = function PriceFieldContainer(props) {
  return /*#__PURE__*/_jsx(BaseInputField, {
    label: props.label,
    name: props.name,
    inputNameAttribute: props.inputNameAttribute,
    autoComplete: props.autoComplete,
    guard: intGuard,
    parse: numberParser,
    format: priceFormatter,
    autoFocus: props.autoFocus,
    placeholder: props.placeholder,
    leftAdornment: props.prefix,
    rightAdornment: props.unit
  });
};
PriceFieldContainer.displayName = 'PriceFieldContainer';